/* eslint-disable import/prefer-default-export */
export function calculateTotal(
  type,
  countries,
  sampleSize,
  extraQuestions,
  adNumber,
  compNumber,
) {
  let price;
  const countryLowerThan = [
    'NL',
    'FR',
    'DE',
    'IT',
    'PL',
    'PT',
    'ES',
    'TR',
    'UK',
    'CA',
    'US',
    'CZ',
  ];
  const countryMiddle = [
    'BE',
    'BG',
    'HU',
    'RO',
    'CN',
    'IN',
    'KR',
    'JP',
    'AR',
    'BR',
    'CL',
    'CO',
    'MX',
  ];
  const countryHigh = [
    'AT',
    'DK',
    'FI',
    'IE',
    'NO',
    'ZA',
    'CH',
    'AU',
    'HK',
    'ID',
    'MY',
    'PH',
    'SG',
    'TH',
    'SE',
    'AE',
    'NZ',
    'TW',
    'VN',
  ];
  if (type === 'Brand health checks') {
    price = countries.map((country) => {
      let countryCode;
      if (countryLowerThan.includes(country.value)) {
        countryCode = 1;
      } else if (countryMiddle.includes(country.value)) {
        countryCode = 15;
      } else if (countryHigh.includes(country.value)) {
        countryCode = 30;
      } else {
        throw Error(
          'The country you selected is not in our operating region. Please contact support',
        );
      }
      return getPrice(1530, countryCode, sampleSize);
    });
  } else if (type === 'Campaign evaluations') {
    price = countries.map((country) => {
      let countryCode;
      if (countryLowerThan.includes(country.value)) {
        countryCode = 1;
      } else if (countryMiddle.includes(country.value)) {
        countryCode = 15;
      } else if (countryHigh.includes(country.value)) {
        countryCode = 30;
      } else {
        throw Error(
          'The country you selected is not in our operating region. Please contact support',
        );
      }
      return getPrice(2080, countryCode, sampleSize);
    });
  } else if (
    type === 'Customer centricity scan'
    || type === 'Employee engagement scan'
  ) {
    return 2950;
  } else {
    price = countries.map((country) => {
      let countryCode;
      if (countryLowerThan.includes(country.value)) {
        countryCode = 1;
      } else if (countryMiddle.includes(country.value)) {
        countryCode = 15;
      } else if (countryHigh.includes(country.value)) {
        countryCode = 30;
      } else {
        throw Error(
          'The country you selected is not in our operating region. Please contact support',
        );
      }
      return getPrice(1417.5, countryCode, sampleSize);
    });
  }
  let totalPrice = price.reduce((acc, curr) => acc + curr);
  if (extraQuestions > 0) {
    totalPrice += 350;
  }
  if (type === 'claims') {
    const finalPrice = totalPrice * compNumber;
    return finalPrice;
  }
  const finalPrice = totalPrice * adNumber * compNumber;
  return finalPrice;
}

function getPrice(basePrice, countryCode, sampleSize) {
  let base = 3.55;
  if (countryCode > 12 && countryCode <= 25) {
    base += 0.1;
  } else if (countryCode > 25) {
    base += 0.3;
  }
  const totalSample = sampleSize.reduce((curr, acc) => curr + acc);
  return basePrice + totalSample * base;
}
